<div mat-dialog-content>
  <div class="row">
    <div class="col" appConfigSettingsParagraph>
      <p class="confirmation-title">
        {{confirmationMessageTitle | translate}}
      </p>
      <p>
        {{confirmationMessage | translate}}
      </p>
      <p *ngIf="htmlContent" class="fontSize" [innerHtml]="htmlContent | translate : {TRANSLATE_PARAM : this.data?.translateParam}"></p>
    </div>
  </div>

  <div *ngIf="hasFreeText" class="row">
    <div class="col">
      <app-area-input class="full-width" [placeholder]="freeTextLabel" [form]="localFormGroup"
        [control]="localFormGroup.get('additionalInfo')" [maxlength]="4000">
      </app-area-input>
    </div>
  </div>
</div>

<div *ngIf="htmlContent" class="align-button" mat-dialog-actions>
  <button class="confirmDialogButtons primary" (click)="onNoClick()"
          appConfigSettingsPrimaryButton>
    {{"Confirmations.Close" | translate}}
  </button>
</div>

<div *ngIf="confirmationMessage" mat-dialog-actions class="align-button">
  <button
    appConfigSettingsPrimaryButton
    type="button"
    class="primary primary-config-button"
    (click)="onNoClick()"
  >
    {{confirmationNO | translate}}
  </button>
  <button
    appConfigSettingsPrimaryButton
    type="button"
    class="primary primary-config-button"
    (click)="onYesClick()"
    cdkFocusInitial
  >
    {{confirmationYES | translate}}
  </button>
</div>
